import React from 'react';
import { EventDetailsTabAssistingAgencyDto } from '@mark43/cad-api';
import { TabIndented } from '../../../../../panels/entity-panels/tabs/tab-indented';
import { TabSection } from '../../../../../panels/entity-panels/tabs/tab-section';
import { AssistingAgenciesSectionContent } from './assisting-agencies-section-content';

export function AssistingAgenciesSection({
    assistingAgencies,
}: {
    assistingAgencies: EventDetailsTabAssistingAgencyDto[];
}): React.ReactElement {
    return (
        <TabSection title="Assisting Agencies">
            {!!assistingAgencies.length && (
                <TabIndented>
                    <AssistingAgenciesSectionContent assistingAgencies={assistingAgencies} />
                </TabIndented>
            )}
        </TabSection>
    );
}
